import { render, staticRenderFns } from "./StudentListCards.vue?vue&type=template&id=5e5693bc&"
import script from "./StudentListCards.vue?vue&type=script&lang=js&"
export * from "./StudentListCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports